import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import avatar from "../../Assets/avatar.png";
import billing from "../../Assets/billing.png";
import billingActive from "../../Assets/billingActive.png";
import avatarActive from "../../Assets/avatarActive.png";
import "./sidenav.css";

function SideNav(props) {
  let { window_path } = props; 
  return (
    <div className="side-nav">
      <div className="settings-header">
        <label>Personal Settings</label>
      </div>
      <div className="links-container">
        <ul>
          <li
            className={
              window_path.includes("settings/profile")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/settings/profile">
              <img
                src={
                  window_path.includes("settings/profile")
                    ? avatarActive
                    : avatar
                }
                alt="process icon"
              ></img>
              Profile
            </NavLink>
          </li>
            <li
              className={
                window_path.includes("/settings/organizations")
                  ? "link-container active-link "
                  : "link-container"
              }
            >
              <NavLink to="/settings/organizations">
                <img
                  src={
                    window_path.includes("/settings/organizations")
                      ? avatarActive
                      : avatar
                  }
                  alt="process icon"
                ></img>
                Organizations
              </NavLink>
            </li>
          {/* <li
                        className={
                            window_path.includes("/settings/notifications")
                                ? "link-container active-link "
                                : "link-container"
                        }
                    >
                        <NavLink to="/settings/notifications">
                            <img
                                src={
                                    window_path.includes("/settings/notifications")
                                        ? notificationsActive
                                        : notifications
                                }
                                alt="process icon"
                            ></img>
                            Notifications
                        </NavLink>
                    </li> */}
                     <li
                        className={
                            window_path.includes("/settings/password")
                                ? "link-container active-link "
                                : "link-container"
                        }
                    >
                        <NavLink to="/settings/password">
                            <img
                                src={
                                    window_path.includes("/settings/password")
                                        ? avatarActive
                                        : avatar
                                }
                                alt="process icon"
                            ></img>
                            Change Password
                        </NavLink>
                    </li> 
          <li
            className={
              window_path.includes("settings/billing")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/settings/billing">
              <img
                src={
                  window_path.includes("settings/billing")
                    ? billingActive
                    : billing
                }
                alt="process icon"
              ></img>
              Billing
            </NavLink>
          </li>
        </ul>
      </div>
      {/* <div className="settings-header">
                <label>Organization Settings</label>
            </div> */}
    </div>
  );
}
const mapStateToProps = (state) => ({
  user: state.user,
  organizations: state.organizations,
});

export default connect(mapStateToProps, null)(SideNav);
